import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import DragItem from '../../../../dnd/DragItem';
import ColumnChecker from '../../ColumnChecker';
import ColumnActions from '../../ColumnActions';
import ColumnUpgrade from '../../ColumnUpgrade';
import ColumnCover from '../../ColumnCover';
import ColumnTrack from '../../ColumnTrack';
import ColumnLabel from '../../ColumnLabel';
import ColumnBpmKey from '../../ColumnBpmKey';
import ColumnMore from '../../ColumnMore';
import ColumnRowActions from '../../ColumnRowActions';

import useTrackAccess from '../../hooks/useTrackAccess';

// React.memo(
const ConnectedRowColumn = ({
  item, index, width, height, className = 'item', style,
  idParent, onClick,
  end,
  isTablet = false
}) => {

  const {
    isEnabled, isDisabled,
    playerLoadSong,
    previewPlayer, isPreview, stylePreview,
    beginDnD, showContextMenu, ContextMenuContent,
    addToCart, isInCart,
    addToPlaylist
  } = useTrackAccess(item, idParent, index);

  const onClickRow = (e) => onClick(item, e);

  const RSizeNumber = 30;
  const RSizeActions = isTablet ? 90 : 50;
  const RSizeCover = 47;
  const RSizeExtra = 35;
  const RSizeMore = 55;
  const RSizeKey = 80; //50

  const PAD = 12;
  const RTotal = RSizeNumber + RSizeActions + RSizeCover + RSizeMore + RSizeKey + RSizeExtra;
  let RSizeTrack = ((width - RTotal) * 70 / 100) - PAD;
  let RSizeLabel = ((width - RTotal) * 30 / 100) - PAD;

  return (
    <>
      <DragItem type={isEnabled ? `TRACK` : `X`} idParent={idParent} begin={beginDnD} end={end} onClick={onClickRow} ContextMenuContent={ContextMenuContent} item={item} className={`${isPreview && `preview`} ${(previewPlayer && !previewPlayer.isPlaying) && 'off'} ${className} ${(isDisabled) && `disabled`} `} style={stylePreview({ width, height })}>
        <ColumnChecker width={RSizeNumber} isDisabled={isDisabled} trackID={item.id} value={item.top} />
        <ColumnActions width={RSizeActions} keyID={item.id} isPreview={(!previewPlayer.isPlaying || !isPreview)} isTablet={isTablet}
            onClickPlayDeckA={playerLoadSong(1)} onClickPlayDeckB={playerLoadSong(2)}
            onPreviewBackward={previewPlayer.backward} onPreviewForward={previewPlayer.forward} />
        <ColumnCover width={RSizeCover} item={item} previewPlayer={previewPlayer} />
        <ColumnTrack width={RSizeTrack} item={item} includeRemixers={true} style={{ marginRight: PAD }} containerStyle={{ marginRight: 0 }}  />
        <ColumnLabel width={RSizeLabel} item={item} style={{ marginRight: PAD }}  />
        { isEnabled ? (
          <>
            <ColumnBpmKey width={RSizeKey} item={item} switchKey={true} />
            <ColumnRowActions width={RSizeExtra} onClickCart={addToCart} isInCart={isInCart} onClickPlaylist={addToPlaylist} />
            <ColumnMore width={RSizeMore} id={item.id} onClick={showContextMenu} />
          </>
        ) : (
          <ColumnUpgrade width={RSizeKey + RSizeMore + RSizeExtra} />
        )}
      </DragItem>
    </>
  )
};

ConnectedRowColumn.propTypes = {
  item: PropTypes.object.isRequired,
  idParent: PropTypes.any,
  index: PropTypes.number.isRequired,
  width: PropTypes.any.isRequired,
  height: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  end: PropTypes.func
}

const RowColumn= connect(
  state => ({
    isTablet: state.layoutTablet
  })
)(ConnectedRowColumn);

export default RowColumn;
